import { render, staticRenderFns } from "./AttachmentChip.vue?vue&type=template&id=c694256a&scoped=true&"
import script from "./AttachmentChip.vue?vue&type=script&lang=js&"
export * from "./AttachmentChip.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentChip.vue?vue&type=style&index=0&id=c694256a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c694256a",
  null
  
)

export default component.exports